import { useCreateDatastoreAndRunners } from '../../../../../../../../state/hooks/RunnerHooks';

export const useCreateDataStoreItemWizard = () => {
  const createDataStoreRunner = useCreateDatastoreAndRunners();

  return createDataStoreRunner;
};
